import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const LogoLink = () => {
  return (
    <Link href='/' >
      <Image
        src={'/marineBroker/logo.png'}
        width={110}
        height={100}
        quality={100}
        className='w-24 2xl:w-28 h-auto'
        alt='Logo'
        priority
      />
    </Link>
  )
}

export default LogoLink